"use strict";
import {http} from '../../../core';
import Config from "../../../app.config";
const RequestService = http.create();


export default {
    //问题经理报表
    //受理的二线支持/事件经理提交的问题请求
    commitedPro(params){
        return  RequestService.get('problem/problem_create_statistics',params)
    },
    //问题经理经手的问题数量
    proManageHandler(params){
        return RequestService.get('problem/problem_manager_handle',params)
    },
    //问题转入变更的数量
    problemToChange(params){
        return RequestService.get('problem/problem_to_change',params)
    },
    //问题转变更数+问题直接关闭比例
    proToChaNproToClose(params){
        return RequestService.get('problem/problem_close_and_change',params)
    }

}
